import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, mergeProps as _mergeProps, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7da761ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "select-wrap" }
const _hoisted_2 = ["value"]
const _hoisted_3 = ["selected", "value"]


import IconArrowBottom from "@/assets/svgs/icon_arrow_bottom.svg";

interface IProps {
  modelValue: string | boolean | number;
  options: { value: string | number; label: string }[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Select',
  props: {
    modelValue: { type: [String, Boolean, Number] },
    options: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {





const updateValue = (e: Event) => {
  emit("update:modelValue", (e.target as HTMLInputElement).value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("select", _mergeProps({
      class: "select",
      value: _ctx.modelValue,
      onChange: updateValue
    }, _ctx.$attrs), [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
        return (_openBlock(), _createElementBlock("option", {
          key: _ctx.options.indexOf(option),
          selected: option.value === _ctx.modelValue,
          value: option.value
        }, _toDisplayString(option.label), 9, _hoisted_3))
      }), 128))
    ], 16, _hoisted_2),
    _createVNode(_unref(IconArrowBottom), { class: "select-icon" })
  ]))
}
}

})